import {
  ChatApi,
  ChatDownloadBlobKnowledgebaseBlobGetRequest,
  ChatPostRequest,
  ChatStreamPostRequest,
  ChatThreadModel,
  InitOverrideFunction,
  KnowledgeBaseReadChatbot,
} from "../../../@api";

export class ChatApiService
  implements Omit<ChatApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: ChatApi) {}

  public async chatDownloadBlobKnowledgebaseBlobGet(
    requestParameters: ChatDownloadBlobKnowledgebaseBlobGetRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Blob> {
    return this.api.chatDownloadBlobKnowledgebaseBlobGet(requestParameters, initOverrides);
  }

  public async chatPost(requestParameters: ChatPostRequest = {}): Promise<ChatThreadModel> {
    return this.api.chatPost(requestParameters);
  }

  public async chatStreamPost(
    requestParameters: ChatStreamPostRequest = {},
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ChatThreadModel> {
    return this.api.chatStreamPost(requestParameters, initOverrides);
  }

  public chatGetKnowledgeBases(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<KnowledgeBaseReadChatbot>> {
    return this.api.chatGetKnowledgeBases(initOverrides);
  }
}
